import { render, staticRenderFns } from "./jinguoinfo1.vue?vue&type=template&id=6af5612e&scoped=true"
import script from "./jinguoinfo1.vue?vue&type=script&lang=js"
export * from "./jinguoinfo1.vue?vue&type=script&lang=js"
import style0 from "./jinguoinfo1.vue?vue&type=style&index=0&id=6af5612e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af5612e",
  null
  
)

export default component.exports